import { createAction } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const UnrecoverableErrorActionTypes = keyMirror({
  CREATE_UNRECOVERABLE_ERROR: null
});
export const createUnrecoverableError = action => createAction(UnrecoverableErrorActionTypes.CREATE_UNRECOVERABLE_ERROR, action);